import { useContext } from "react";
import { Box, styled } from "@mui/material";
import { RoomsRealtimeContext } from "@common/components/ListDetailViews/Layout/context";
import React from "react";
import CardContent from "./CardContent";
import { CardHolder } from "..";
import DeviceHeader from "../../DeviceHeader";
import CardFooter from "../footer";
import { ConferenceParticipant } from "@services/meetings/types";
import { GraphType } from "@services/monitoring/types";

const MetricCardContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

const GraphContainer = styled(Box)(({ theme }) => ({
  backgroundColor: theme.palette.background.default,
  paddingLeft: theme.spacing(1),
  paddingRight: theme.spacing(1),
  paddingBottom: theme.spacing(2),
  paddingTop: theme.spacing(1),
  height: "100%",
}));

const MetricCardHeaderContainer = styled(Box)(({ theme }) => ({}));

const Card = (props: {
  participant: ConferenceParticipant;
  type: GraphType;
}) => {
  const { participant, type } = props;

  const context = useContext(RoomsRealtimeContext);
  const meeting = { ...context.detail?.meeting };

  const { device } = participant;

  return (
    <CardHolder device={device} landscape>
      <MetricCardContainer>
        <MetricCardHeaderContainer>
          <DeviceHeader device={device} />
        </MetricCardHeaderContainer>
        <GraphContainer>
          <CardContent
            device={device}
            participant={participant}
            meeting={meeting}
            graphType={type}
          />
        </GraphContainer>
      </MetricCardContainer>
      <CardFooter device={device} landscape />
    </CardHolder>
  );
};

export default Card;
